.courseItem {
    --course-item-line-clamp: ;
    --course-item-rows: 1;
    --course-item-background: var(--bi-color-surface);
    grid-row: span var(--course-item-rows);
    min-width: 0;

    .course {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        overflow: hidden;
        gap: var(--bi-scale-2x);
        border-radius: var(--bi-radius-medium);
        border: var(--bi-stroke-thin) solid var(--bi-color-stroke-strong);
        background: var(--course-item-background);
        background-repeat: no-repeat;
        color: var(--bi-color-text);
        text-decoration: none;
        width: 100%;
        box-sizing: border-box;
        text-align: left;
        font: var(--bi-font-body-large);
        height: 100%;
        padding: var(--bi-scale-2x) var(--bi-scale-3x);

        &[data-variant='Elective'] {
            --course-item-background: var(--dashed-border);
            border: none;
        }

        &[data-variant='Webinar'] {
            border-color: color-mix(in srgb, var(--bi-basic-white) 40%, transparent);
            --course-item-background: var(--bi-color-background);
        }

        &:is(a, button) {
            cursor: pointer;
            &:hover {
                background:
                    linear-gradient(0deg, var(--bi-states-hover) 0%, var(--bi-states-hover) 100%),
                    var(--course-item-background);
            }
            &:active {
                background:
                    linear-gradient(0deg, var(--bi-states-press) 0%, var(--bi-states-press) 100%),
                    var(--course-item-background);
            }
            &:focus-visible {
                box-shadow:
                    inset 0 0 0 2px var(--bi-states-focus-background),
                    inset 0 0 0 4px var(--bi-states-focus);
                outline: none;
                border-radius: var(--bi-radius-medium);
            }
        }

        .courseContent {
            display: flex;
            flex-direction: column;
            gap: var(--bi-scale-1x);
            overflow: hidden;
            min-width: 0;
        }

        .title {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: var(--course-item-line-clamp);
            line-clamp: var(--course-item-line-clamp);
        }

        .label {
            font: var(--bi-font-body-xs);
            color: var(--bi-color-text-accent);
        }

        .credits {
            line-height: 1.5rem;
            white-space: nowrap;
        }
    }

    &[data-rows='1'] {
        .title {
            display: initial;
            white-space: nowrap;
        }
    }

    &[data-rows='2'] {
        --course-item-rows: 2;
        --course-item-line-clamp: 3;
    }
    &[data-rows='3'] {
        --course-item-rows: 3;
        --course-item-line-clamp: 6;
    }
    &[data-rows='4'] {
        --course-item-rows: 4;
        --course-item-line-clamp: 8;
    }
}
